import styled from 'styled-components';

export const UserMenuWrapper = styled.div`
  display: flex;
  gap: 10px;
`;
